import React from 'react'

const Events = () => {
  return (
    <h1>Teste</h1>
  )
}

export default Events